import { Link } from 'react-router-dom';
import { theme } from '../styles/theme';
import { Logo } from './Logo';

export function Footer() {
  return (
    <footer style={{
      borderTop: `5px solid ${theme.divider}`,
      background: theme.bgFooter,
      padding: '40px 24px 24px',
      marginTop: 80,
    }}>
      <div style={{
        maxWidth: theme.maxWidth,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto',
        alignItems: 'center',
        gap: 24,
        flexWrap: 'wrap',
      }}>
        <Link to="/" style={{ color: theme.brand, display: 'flex' }}>
          <Logo height={48} />
        </Link>

        <nav style={{
          display: 'flex',
          gap: 24,
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}>
          <Linky to="/compose">COMPOSE by NULED</Linky>
          <Linky to="/arma-tu-riel">Arma tu riel</Linky>
          <Linky to="/distribuidor">Vuélvete distribuidor</Linky>
          <Linky to="/contacto">Contáctanos</Linky>
          <Linky to="/facturacion">Facturación</Linky>
        </nav>

        <a
          href="https://instagram.com/nuled.mx"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram NULED"
          style={{ color: theme.brand, display: 'flex' }}
        >
          <InstagramIcon />
        </a>
      </div>

      <div style={{
        maxWidth: theme.maxWidth,
        margin: '24px auto 0',
        paddingTop: 16,
        borderTop: `1px solid ${theme.border}`,
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 12,
        color: theme.textMuted,
        fontSize: 12,
      }}>
        <div>© {new Date().getFullYear()} NULED. Todos los derechos reservados.</div>
        <div>Distribuidor educador Lutron · México</div>
      </div>
    </footer>
  );
}

function Linky({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      style={{
        color: theme.brand,
        textDecoration: 'none',
        fontSize: 14,
      }}
    >
      {children}
    </Link>
  );
}

function InstagramIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" />
    </svg>
  );
}
